import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, useHistory } from 'react-router-dom';

import OnboardingShell, { useOnboardingStyles } from '../OnboardingShell';
import GenericState from '../../../MyComponents/GenericLoadingErrorState/GenericState';
import userApi from '../../../Api/userApi';
import store from '../../../redux/store';
import { updateUserSubscription } from '../../../redux/actions';
import { PROFILE_LINK } from '../../../common/urlLinks';
import { cx } from '../../Home/HomeDashboard/dashboardStyles';

/** Confirms cancelling the subscription, then returns to the profile. */
const CancelStage = () => {
    const classes = useOnboardingStyles();
    const history = useHistory();
    const [cancelling, setCancelling] = useState(false);

    const cancel = () => {
        setCancelling(true);
        userApi
            .cancelSubscription()
            .then(() => userApi.getExtendedProfile())
            .then((res) => {
                store.dispatch(updateUserSubscription(res.data.subscription));
                history.push(PROFILE_LINK);
            })
            .catch((err) => {
                console.error('Unable to cancel the subscription', err);
                history.push(PROFILE_LINK);
            });
    };

    return (
        <OnboardingShell
            title={<FormattedMessage id="onboarding.cancel.message" />}
            lead={<FormattedMessage id="redesign.onboarding.cancel.lead" />}
        >
            <div className={cx(classes.card, classes.centered)}>
                {cancelling ? (
                    <GenericState isLoading={true} inline={true} />
                ) : (
                    <div className={classes.actions} style={{ marginTop: 0 }}>
                        <Link to={PROFILE_LINK} className={classes.primary}>
                            <FormattedMessage id="onboarding.cancel.no" />
                        </Link>
                        <button type="button" onClick={cancel} className={classes.danger}>
                            <FormattedMessage id="onboarding.cancel.yes" />
                        </button>
                    </div>
                )}
            </div>
        </OnboardingShell>
    );
};

export default CancelStage;
